// import { motion } from "framer-motion";
// import {
//   Code,
//   ArrowRight,
//   CheckCircle,
//   Zap,
//   Globe,
//   Shield,
// } from "lucide-react";

// export default function WebDevelopmentPage() {
//   return (
//     <main style={{ backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif" }}>

//       {/* ================= HERO SECTION ================= */}
//       <section
//         style={{
//           background: `
//             linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),
//             url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1920&q=80')
//           `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "90px 20px",
//             color: "white",
//           }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "16px",
//                 marginBottom: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   background: "rgba(255,255,255,0.2)",
//                   padding: "14px",
//                   borderRadius: "8px",
//                 }}
//               >
//                 <Code size={36} />
//               </div>
//               <span style={{ fontSize: "14px", fontWeight: 600 }}>
//                 DIGITAL TRANSFORMATION
//               </span>
//             </div>

//             <h1
//               style={{
//                 fontSize: "48px",
//                 fontWeight: "bold",
//                 marginBottom: "20px",
//               }}
//             >
//               Professional Website Development
//             </h1>

//             <p style={{ fontSize: "18px", maxWidth: "600px", opacity: 0.95 }}>
//               Build stunning, responsive websites that convert visitors into
//               customers. From concept to deployment.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= WHAT WE DELIVER ================= */}
//       <section style={{ padding: "80px 20px" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "10px" }}>
//             What We Deliver
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "30px",
//             }}
//           >
//             {[
//               {
//                 icon: Globe,
//                 title: "Responsive Design",
//                 desc: "Perfect on all devices and screen sizes",
//               },
//               {
//                 icon: Zap,
//                 title: "Lightning Fast",
//                 desc: "Optimized for speed and performance",
//               },
//               {
//                 icon: Shield,
//                 title: "Secure & Scalable",
//                 desc: "Built with security best practices",
//               },
//             ].map((item, idx) => {
//               const Icon = item.icon;
//               return (
//                 <motion.div
//                   key={idx}
//                   whileHover={{ y: -5 }}
//                   style={{
//                     background: "#ffffff",
//                     padding: "30px",
//                     borderRadius: "12px",
//                     boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "#0052CC",
//                       width: "50px",
//                       height: "50px",
//                       borderRadius: "10px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginBottom: "20px",
//                     }}
//                   >
//                     <Icon color="white" size={26} />
//                   </div>

//                   <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>
//                     {item.title}
//                   </h3>
//                   <p style={{ color: "#718096", marginTop: "10px" }}>
//                     {item.desc}
//                   </p>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* ================= DEVELOPMENT PROCESS ================= */}
//       <section style={{ padding: "80px 20px", background: "#f8f9fb" }}>
//         <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               textAlign: "center",
//               marginBottom: "15px",
//             }}
//           >
//             Our Development Process
//           </h2>
//           <p
//             style={{
//               textAlign: "center",
//               color: "#718096",
//               marginBottom: "60px",
//             }}
//           >
//             A structured approach to building high-quality websites
//           </p>

//           <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
//             {[
//               ["1", "Discovery & Planning", "Understand goals and audience"],
//               ["2", "Design & UX", "Create intuitive and engaging UI"],
//               ["3", "Development", "Clean, scalable, modern code"],
//               ["4", "Testing & QA", "Performance & security checks"],
//               ["5", "Launch & Support", "Deployment and maintenance"],
//             ].map(([step, title, desc], idx) => (
//               <motion.div
//                 key={idx}
//                 whileHover={{ x: 5 }}
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "auto 1fr",
//                   gap: "25px",
//                   background: "#ffffff",
//                   padding: "30px",
//                   borderRadius: "14px",
//                   boxShadow: "0 4px 20px rgba(0,82,204,0.08)",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     background: "#0052CC",
//                     color: "white",
//                     fontWeight: "bold",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "18px",
//                   }}
//                 >
//                   {step}
//                 </div>

//                 <div>
//                   <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>
//                     {title}
//                   </h3>
//                   <p style={{ color: "#718096", marginTop: "6px" }}>{desc}</p>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ================= CTA ================= */}
//       <section
//         style={{
//           background: "linear-gradient(135deg, #0052CC, #004DD4)",
//           padding: "80px 20px",
//           color: "white",
//           textAlign: "center",
//         }}
//       >
//         <h2 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "15px" }}>
//           Ready to Build Your Website?
//         </h2>
//         <p style={{ fontSize: "18px", marginBottom: "30px", opacity: 0.9 }}>
//           Let’s create something powerful together
//         </p>
//         <a
//           href="/contact"
//           style={{
//             background: "white",
//             color: "#0052CC",
//             padding: "14px 34px",
//             borderRadius: "8px",
//             fontWeight: 600,
//             textDecoration: "none",
//             display: "inline-flex",
//             alignItems: "center",
//             gap: "10px",
//           }}
//         >
//           Get Started <ArrowRight size={20} />
//         </a>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  Code2,
  ArrowRight,
  Globe,
  ShieldCheck,
  Zap,
  Layout,
  Cpu,
  Smartphone,
  Search,
  CheckCircle2,
  Server,
  MousePointer2,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function WebDevelopmentPage() {
  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[400px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.1]"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Web Engineering
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Infronex <span className="text-indigo-400">Web</span> Solutions.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              Build a high-performing website that grows your business. We
              combine clean code with modern design to help Indian brands reach
              a global audience.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all flex items-center gap-2 shadow-lg"
              >
                Request Free Quote <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= STRATEGIC VALUE SECTION (NEW CONTENT) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <motion.div {...fadeUp}>
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              Why Your Business Needs a Professional Website
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed font-light text-lg">
              In today's digital world, your website is often the first point of
              contact for your customers. A slow or outdated site can cost you
              valuable leads.
            </p>
            <p className="text-slate-600 mb-8 leading-relaxed font-light">
              At Infronex, we don't just "make websites." We build **business
              tools**. Our websites are designed to load fast on 4G/5G networks,
              look perfect on mobile devices, and rank high on Google Search.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Mobile-First Approach",
                "SEO Friendly Structure",
                "Fast Loading Speeds",
                "Easy Content Management",
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircle2
                    className="text-indigo-600 shrink-0"
                    size={18}
                  />
                  <span className="text-sm font-medium text-slate-700">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80"
              alt="Web Analytics"
              className="rounded-2xl shadow-2xl border border-slate-100"
            />
          </div>
        </div>
      </section>

      {/* ================= CAPABILITIES GRID ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Service Focus
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight text-left md:text-center">
              Technical Deliverables
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Smartphone,
                title: "Mobile Optimization",
                desc: "India is mobile-first. We ensure your site works perfectly on every smartphone and tablet.",
              },
              {
                icon: Search,
                title: "Search Engine Ready",
                desc: "Built-in SEO features to help your business appear on the first page of Google results.",
              },
              {
                icon: ShieldCheck,
                title: "Secure Hosting",
                desc: "We provide high-security servers and SSL certificates to keep your customer data safe.",
              },
              {
                icon: MousePointer2,
                title: "User-Centric UI/UX",
                desc: "Clean, professional designs that make it easy for your customers to find information.",
              },
              {
                icon: Zap,
                title: "Speed Optimization",
                desc: "Highly optimized code to ensure sub-second loading, reducing bounce rates.",
              },
              {
                icon: Server,
                title: "CMS Integration",
                desc: "Easy-to-use panels like WordPress or Custom Dashboards to update your content.",
              },
            ].map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-200 bg-white hover:border-indigo-500/30 hover:shadow-xl transition-all duration-300 text-left"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6 shadow-sm">
                  <item.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TECHNOLOGY STACK SECTION ================= */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="bg-[#0f172a] rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-16 relative overflow-hidden">
            {/* Glow effect */}
            <div className="absolute top-0 right-0 w-40 h-40 sm:w-64 sm:h-64 bg-indigo-600/10 blur-[90px] rounded-full" />

            <div className="relative z-10 text-center md:text-left">
              {/* Heading */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6">
                Modern Technology Stack
              </h2>

              {/* Description */}
              <p className="text-slate-400 mb-8 md:mb-12 max-w-xl mx-auto md:mx-0 font-light text-sm sm:text-base">
                We use the world's most trusted technologies to build websites
                that are scalable, future-proof, and easy to maintain.
              </p>

              {/* Tech Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
                {[
                  "React / Next.js",
                  "Node.js Backend",
                  "AWS Cloud",
                  "Tailwind CSS",
                  "PostgreSQL / MongoDB",
                  "Google Analytics",
                  "Headless CMS",
                  "REST / GraphQL",
                ].map((tech) => (
                  <div
                    key={tech}
                    className="bg-white/5 border border-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 flex items-center gap-3"
                  >
                    <CheckCircle2
                      size={16}
                      className="text-indigo-400 shrink-0"
                    />
                    <span className="text-[12px] sm:text-[13px] text-slate-300 font-medium tracking-wide">
                      {tech}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Ready to Build Your Online Presence?
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            From single landing pages to large corporate portals, Infronex has
            the expertise to bring your vision to life. Let’s talk about your
            project today.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Start Conversation with Experts
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}